import React, { useEffect } from 'react';
import { CloseIcon } from '../utils/icons';

/**
 * Reusable modal wrapper. Handles overlay click-to-close, escape key, and consistent header.
 *
 * Usage:
 *   <Modal title="Add User" onClose={...} size="sm">
 *     <div className="modal-body">...</div>
 *     <div className="modal-footer">...</div>
 *   </Modal>
 */
export default function Modal({ title, size, onClose, children }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className={`modal ${size === 'sm' ? 'modal--sm' : ''} animate-fade-in`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2 className="modal-title">{title}</h2>
          <button className="btn-icon modal-close" onClick={onClose}><CloseIcon /></button>
        </div>
        {children}
      </div>
    </div>
  );
}
